export default __webpack_public_path__ + "static/media/151-doorway.10cc9a14.png";